let commonApi = location.origin;
if (window.__env) {
    window.commonApi = window.__env;
    window.commonApi.SSO_SCOPE = "data openid profile app process triple task stats profile_edit entrust entrust_edit"
} else {
    window.commonApi = {
        INFOPLUS_URL: `${commonApi}/infoplus/apis/v2`,
        SSO_URL: `https://cloud.ketanyun.cn/sso`,
        SSO_SCOPE: "data openid profile app process triple task stats profile_edit entrust entrust_edit",
        SSO_KEY: "K04UReiYLCZFPmJ94qNr",
        PATH: "/taskcenter-six",
        INFOPLUS_BASE_URL: `${commonApi}/infoplus`,
        TASKCENTER_API_URL: `${commonApi}/taskcenter-api`,
        KNOWLEDGE_URL: `${commonApi}/bus/graphql/knowledge`,
        // TASKAPI_URL: `${commonApi}/bus/graphql/taskapi`,
        TASKAPI_URL: '',
        VERSION: "20230321"
    }
}

let redirect_uri = encodeURIComponent(window.location.href);
let client_id = window.commonApi.SSO_KEY;
let scope = window.commonApi.SSO_SCOPE;
let authority = window.commonApi.SSO_URL + "/oauth2";
export const oidcSettings = {
    authority: authority,
    metadata: {
        issuer: authority,
        authorization_endpoint: authority + "/authorize",
        userinfo_endpoint: authority + "/userinfo",
        end_session_endpoint: window.commonApi.SSO_URL + "/logout?redirect_uri=" + redirect_uri,
        jwks_uri: authority + "/jwks.json"
    },
    clientId: client_id,
    redirectUri: window.location.origin + window.commonApi.PATH + "/workflow/oidcCallback",
    responseType: "id_token token",
    scope: scope
};



// WEBPACK FOOTER //
// ./src/store/config/oidc.js